import { useSnackbar as useNotistackSnackbar } from 'notistack';
/**
 * @returns Vraci tuple `[showMessage, closeMessage]`
 * - `showMessage: (message, options) => string` Zobrazeni zpravy. Vraci `key` k zprave. Nastaveni:
 *    - **Vsechny vlastnosti material-ui Snackbaru**
 *    - `action: Node` - node zobrazovane akce. By default je klik na akci interpretovan jako `close`. Custom `onclick`
 *      handler implementuje option `onClickAction`
 *    - `autoHideDuration: number` - pocet milisekund zobrazeni zpravy.
 *    - `key: string` - vlastni klic zpravy. **Vhodne definovat pro persist zpravy**
 *    - `persist: boolean` - perzistnetne zobrazena zprava. Skryt je ji mozne pomoci funkce `closeMessage` ziskane
 *       z tuple `useSnackbar`.
 *    - `preventDuplicate: boolean` - pokud je `true` duplnicitni message se nebude zobrazovat. **By default je prevence
 *       duplicit zapnuta na urovni provideru**.
 *    - `variant: 'none' | 'info' | 'success' | 'warning' | 'error'` - variant zobrazeni zpravy
 * - `closeMessage: (key) => void` - uzavreni message s klicem `key`
 */

export default function useSnackbar() {
  var _useNotistackSnackbar = useNotistackSnackbar(),
      closeSnackbar = _useNotistackSnackbar.closeSnackbar,
      enqueueSnackbar = _useNotistackSnackbar.enqueueSnackbar;

  return [enqueueSnackbar, closeSnackbar];
}